import { useQuery } from "@tanstack/react-query";
import { analyticsApi } from "./analytics.api";
import { analyticsKeys } from "./analytics.keys";
import type { TGetAnalyticsData } from "./types";

export const useGetAnalyticsSelectionQuery = ({
  storyId,
  versionId,
  enabled = true,
}: {
  storyId?: string;
  versionId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [...analyticsKeys.selection, storyId ?? "", versionId ?? ""],
    queryFn: () => analyticsApi.getSelection({ storyId, versionId }),
    enabled: enabled && Boolean(storyId || versionId),
    // Titles change rarely and this only runs to label a deep link, so a single
    // fetch per selection is enough.
    staleTime: Infinity,
    retry: 1,
  });
};

export const useGetAnalyticsDataQuery = ({
  query,
  params,
  enabled = true,
}: TGetAnalyticsData) => {
  return useQuery({
    queryKey: [...analyticsKeys.analytics, query, params],
    queryFn: ({ signal }) =>
      analyticsApi.getAnalyticsData({ query, params }, signal),
    staleTime: 0,
    gcTime: 0,
    enabled,
  });
};
